import React, { useState } from "react";
import styled from "styled-components";

const FieldInformation = ({ message = undefined }) => {
  return <>{message && <MessageStyled>{message}</MessageStyled>}</>;
};

const MessageStyled = styled.div`
  margin-left: 15px;
  margin-top: 5px;
  font-size: 0.8em;
`;

export default FieldInformation;
